import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HotelHeadlineComponent(_ref) {
  var headline = _ref.headline;
  var getTypographyProps = useSemanticTypography();
  if (!headline) {
    return null;
  }
  return _jsx(Text, _objectSpread(_objectSpread({
    mt: "md",
    "data-testid": "hdp_hotelHeadline"
  }, getTypographyProps({}, headlineSemanticTypography)), {}, {
    children: headline
  }));
}
var headlineSemanticTypography = {
  textStyle: 'body-m-regular'
};